import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { LicenseBadge } from "./LicenseAlerts";

export const DriverRow = ({ driver }) => {
  const navigate = useNavigate();
  const archived = driver.status === "archived";
  const open = () => navigate(`/admin/drivers/${driver.user_id}`);
  return (
    <tr role="link" tabIndex={0} onClick={open} onKeyDown={(e) => { if (e.key === "Enter") open(); }}
      className={`border-t border-slate-100 cursor-pointer transition-colors focus:outline-none focus-visible:bg-blue-50 ${archived ? "bg-slate-50/60 text-slate-500" : "hover:bg-blue-50/60"}`} data-testid={`driver-row-${driver.user_id}`}>
      <td className="px-4 py-3 max-w-[200px] md:max-w-none">
        <div className="font-semibold truncate" data-testid={`driver-name-${driver.user_id}`}>{driver.name || "—"}</div>
        <div className="sm:hidden text-xs text-slate-500 truncate">{driver.phone || "No phone"}</div>
        {!archived && <div className="mt-1"><LicenseBadge expiry={driver.license_expiry} testId={`driver-license-badge-${driver.user_id}`} /></div>}
        {!driver.has_login && <div className="mt-1 text-[11px] text-amber-700" data-testid={`driver-no-login-${driver.user_id}`}>No username yet — open to set one</div>}
      </td>
      <td className="hidden sm:table-cell px-4 py-3 text-slate-600 whitespace-nowrap" data-testid={`driver-phone-${driver.user_id}`}>{driver.phone || "—"}</td>
      <td className="hidden sm:table-cell px-4 py-3" data-testid={`driver-active-loads-${driver.user_id}`}>{driver.active_loads}</td>
      <td className="px-4 py-3">
        <span className={`pill ${archived ? "bg-slate-100 text-slate-600 border border-slate-200" : "bg-emerald-50 text-emerald-700 border border-emerald-200"}`} data-testid={`driver-status-${driver.user_id}`}>
          {archived ? "Archived" : "Active"}
        </span>
      </td>
      <td className="px-2 py-3 text-right text-slate-400"><ChevronRight className="w-4 h-4 inline" /></td>
    </tr>
  );
};
